module.exports = __webpack_public_path__ + "img/loading.7fc09f7a.gif";